import router from "./router"
// import store from './store'
import { getToken } from '@/common/auth'

const whiteList = ['/index', '/login', '/register', '/registerInfo', '/resetPassword', '/admLogin'] // 不重定向白名单
router.beforeEach((to, from, next) => {
  if (getToken()) {
    next()

  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js